import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../../../providers/shared.service';
import { FormControl } from '@angular/forms';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/providers/api.service';
import { TranslateService } from '@ngx-translate/core';
import { MessagingService } from 'src/app/providers/messaging.service';
@Component({
  selector: 'sm-customers-view-details',
  templateUrl: './customers-view-details.component.html',
  styleUrls: ['./customers-view-details.component.scss']
})
export class CustomersViewDetailsComponentForDet implements OnInit {

  constructor(private _navService: NavigationService,   private dialog:MatDialog, private route: ActivatedRoute, private _apiService: ApiService, private _modelRef: MatDialog, private sharedService: SharedService, private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging, private loaderservice: LoaderServiceService, private translateService: TranslateService, private router: Router) { 
    this._navService.hideSidebarAndNav = false;
  }

  
  ngOnInit(): void {
  }

}
